import React, { useState } from 'react';
import i18next from 'i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';

import axiosInstance from '../../../config/axiosConfig';

const t = (i18nKey, params) => i18next.t(`userDashboard.candidate.${i18nKey}`, params);

const CandidateAttemptPDF = ({ data, pdfLoading, setPdfLoading, pdfUrl, setPdfUrl, toast }) => {
    const [showModalPdf, setShowModalPdf] = useState(false);

    const { company_id, candidate_id, attempt_ref } = data;

    if (Object.values({ company_id, candidate_id, attempt_ref }).some(value => !value)) {
        return toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue empêchant le téléchargement de ce PDF', life: 3000 });
    }

    const handleDownloadPdf = async () => {
        setPdfLoading(true);
        try {
            const response = await axiosInstance({
                url: `/dashboard/candidates/${company_id}/${candidate_id}/${attempt_ref}/generateCandidatePdf`,
                method: 'POST',
                responseType: 'blob',
            });

            if (response.headers['content-type'] !== 'application/pdf') return;

            const contentDisposition = response.headers['content-disposition'];
            let filename = `Candidate_Report_${attempt_ref}.pdf`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch.length > 1) {
                    filename = filenameMatch[1];
                }
            }

            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = window.URL.createObjectURL(pdfBlob);

            const link = document.createElement('a');
            link.href = pdfUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(pdfUrl);

        } catch (error) {
            console.error('Error downloading PDF:', error);
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue empêchant le téléchargement de ce PDF', life: 3000 });
        } finally {
            setPdfLoading(false);
        }
    };

    const fetchPdf = async () => {
        setPdfLoading(true);

        if (pdfUrl) {
            setPdfLoading(false);
            setShowModalPdf(true);
            return;
        }

        try {
            const response = await axiosInstance({
                url: `/dashboard/candidates/${company_id}/${candidate_id}/${attempt_ref}/generateCandidatePdf`,
                method: 'POST',
                responseType: 'blob',
            });

            if (response.headers['content-type'] !== 'application/pdf') return;

            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const urlPdf = window.URL.createObjectURL(pdfBlob);

            setPdfUrl(urlPdf);
            setShowModalPdf(true);
        } catch (error) {
            console.error("Error fetching PDF:", error);
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue empêchant l\'affichage de ce PDF', life: 3000 });
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <>
            <Dialog
                header="Candidate PDF"
                dismissableMask={true}
                visible={showModalPdf}
                onHide={() => setShowModalPdf(false)}
                style={{ width: '100vw', height: '100vh', maxWidth: '80vw', maxHeight: '100vh' }}
                modal
            >
                <iframe src={pdfUrl} width="100%" height="100%" title="Candidate PDF" />
            </Dialog>

            <button className="button is-outlined radius-8"
                onClick={handleDownloadPdf}
                disabled={pdfLoading}
            >
                <span className="icon">
                    {pdfLoading ? (
                        <ProgressSpinner style={{ width: '20px', height: '20px' }} />
                    ) : (
                        <i className="pi pi-download"></i>
                    )}
                </span>
                <span>{t('download_report')}</span>
            </button>

            <a
                className="button is-outlined ml-1 px-4 radius-8"
                onClick={fetchPdf}
                disabled={pdfLoading}
            >
                <span className="icon is-small">
                    {pdfLoading ? (
                        <ProgressSpinner style={{ width: '20px', height: '20px' }} />
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style={{ fill: '#363636' }}>
                            <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                        </svg>
                    )}
                </span>
            </a>
        </>
    );
};

export default CandidateAttemptPDF;